export default {
  DOUBLE: { label: "Double", value: ["DOUBLE_QK"] },
  SINGLE: { label: "Single", value: ["SINGLE_DK"] },
  TWIN: { label: "Twin", value: ["DOUBLE_DOUBLE"] },
  TRIPLE: { label: "Triple", value: ["TRIPLE"] },
  QUAD: { label: "Quad", value: ["QUAD"] },
};
